<app-dialog-header [title]=" createNew ? 'New project' : 'Edit project' "></app-dialog-header>
<app-add-edit-project
  [project]="data"
  [submitText]="createNew ? 'Create project' : 'Save'"
  (projectSubmitted)="Submit($event)"
  (cancel)="closeDialog()"
>
</app-add-edit-project>
